var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPromoMenu = function SvgPromoMenu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0655 2.5H8.28008C7.31369 2.5 6.52301 3.27727 6.52301 4.22727V6.81818H8.28008V5.09091H17.0655V18.9091H8.28008V17.1818H6.52301V19.7727C6.52301 20.7227 7.31369 21.5 8.28008 21.5H17.0655C18.0318 21.5 18.8225 20.7227 18.8225 19.7727V4.22727C18.8225 3.27727 18.0318 2.5 17.0655 2.5ZM6.53179 13.2695L4.29152 11.0673L3.17578 12.1641L6.52301 15.4545L12.8397 9.245L11.7239 8.14818L6.53179 13.2695Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPromoMenu);
export default ForwardRef;